import { Trans } from '@lingui/react/macro'
import clsx from 'clsx'
import styles from '../../restricted-data/components/RestrictedDataBanner.module.css'
import { InviteReferralModal } from './InviteReferralModal'

export const ReferralProgramBanner = () => {
  return (
    <InviteReferralModal
      dialogTrigger={
        <div className={styles.gradient}>
          <div className={clsx(styles.container, 'flex flex-col')}>
            <div className="mb-10">
              <img
                className="absolute top-0 left-[50%] w-[120px] translate-x-[-50%] translate-y-[-46px]"
                src="/images/three-tier.png"
                alt=""
              />
            </div>
            <p className={styles.title}>
              <Trans>Referral Program</Trans>
            </p>
            <p className={styles.description}>
              <Trans>Invite new users to join and you’ll both earn rewards!</Trans>
            </p>
          </div>
        </div>
      }
    />
  )
}
